export default __webpack_public_path__ + "assets/images/7ea8808ba37dfa31b1c101f35a9315c3.png";